import { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";

export default function ForcePasswordChange() {
  const { setUser, logout } = useAuth();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw.length < 8) { setError("La password deve avere almeno 8 caratteri"); return; }
    if (pw !== pw2) { setError("Le password non coincidono"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { new_password: pw });
      const { data } = await api.get("/auth/me");
      setUser(data);
      toast.success("Password aggiornata");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Errore");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6" data-testid="force-password-change">
      <Card className="w-full max-w-sm p-8 space-y-6">
        <div className="flex flex-col items-center text-center gap-2">
          <div className="flex items-center justify-center h-12 w-12 rounded-full bg-primary/10">
            <KeyRound className="h-6 w-6 text-primary" />
          </div>
          <h1 className="font-heading text-xl font-bold">Imposta una nuova password</h1>
          <p className="text-sm text-muted-foreground">Per motivi di sicurezza devi cambiare la password temporanea prima di continuare.</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="new-pw">Nuova password</Label>
            <Input id="new-pw" data-testid="force-pw-input" type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="Almeno 8 caratteri" required />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="new-pw2">Conferma password</Label>
            <Input id="new-pw2" data-testid="force-pw-confirm-input" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} placeholder="Ripeti la password" required />
          </div>
          {error && <p className="text-sm text-destructive" data-testid="force-pw-error">{error}</p>}
          <Button type="submit" className="w-full" data-testid="force-pw-submit" disabled={busy}>
            {busy ? "Salvataggio…" : "Salva e continua"}
          </Button>
        </form>
        <button className="text-xs text-muted-foreground hover:text-foreground w-full text-center" data-testid="force-pw-logout" onClick={logout}>Esci</button>
      </Card>
    </div>
  );
}
